.container {
  display: flex;
  flex-direction: column;
}

.title {
  display: flex;
}

.formControl {
  width: 100%;
}

.option {
  width: 100%;
}
